import { render, staticRenderFns } from "./LocationConfirm.vue?vue&type=template&id=00cfab1a"
import script from "./LocationConfirm.vue?vue&type=script&lang=js"
export * from "./LocationConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports